/**
 * @generated SignedSource<<2491bb20bb2db91cefd6298e0dd502b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentSchemaRenderContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"blockquoteQuoteContent" | "imageContent" | "inlineWidgetContent" | "photoGalleryWidgetContent" | "scmpYoutubeContent">;
  readonly " $fragmentType": "contentSchemaRenderContent";
};
export type contentSchemaRenderContent$key = {
  readonly " $data"?: contentSchemaRenderContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentSchemaRenderContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "scmpYoutubeContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "imageContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteQuoteContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "inlineWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "photoGalleryWidgetContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "eef4a52b333d67a9109a4a435d2ca6da";

export default node;
